import { DataGridPremium, GridColDef, GridRenderCellParams, GridValueGetterParams, useGridApiRef } from '@mui/x-data-grid-premium';
import { Status, useFetch } from '../../hooks/useFetch';
import { useMemo } from 'react';
import dayjs from 'dayjs'
import { AuditLogItem } from '@aviation/cabinapp-audit-service-sdk';
import AuditStateChip from './AuditStateChip';
export interface IDateValueProps {
    date?: Date;
}

export interface ITimeValueProps {
    date?: Date;
}

export interface IAuditLogGridProps {
    dateFrom?: string;
    dateTo?: string;
    tabIndex: number;
}

function AuditLogGrid(props : IAuditLogGridProps) {
    const apiRef = useGridApiRef();
    const { status, data = [] } = useFetch<Array<AuditLogItem>>(`/api/audit/from/${props.dateFrom}/to/${props.dateTo}`, (response) => response);

    const columns: GridColDef[] = [
        { field: 'Type', headerName: 'State', minWidth: 100, flex: 1, renderCell: (params: GridRenderCellParams) => (<AuditStateChip state={params.row.Type} />)},
        { field: 'Date', headerName: 'Date', minWidth: 100, renderCell: (params: GridRenderCellParams<Date>) => dayjs(params.value).format('DD.MM.YYYY') },
        { field: 'Time', headerName: 'Time', minWidth: 100, renderCell: (params: GridRenderCellParams<Date>) => dayjs(params.value).format('HH:mm') },
        { field: 'Group', headerName: 'Event', minWidth: 250 },
        { field: 'Description', headerName: 'Description', minWidth: 400 },
        { field: 'Username', headerName: 'Modified by', minWidth: 400 }, 
    ];

    const filterBy =(tabIndex : number, item : (AuditLogItem)) : Boolean => {
        switch(tabIndex) {
            case 0: // IDPS
                return item.Group?.toLowerCase().startsWith('idps') ?? false;
            
            case 1: // Newskies
                return item.Group?.toLowerCase().startsWith('newskies') ?? false;

            case 2:
                return item.Group?.toLowerCase().startsWith('flight api') ?? false;

            default:
                return true;
        }

    };

    const aggregatedData = useMemo(() => {
        return data.filter(o => filterBy(props.tabIndex, o)).map(o => {
            return {
                id: `${o.ClientCode ?? 'Unkown'}#${o.Timestamp}`,
                Date: o.Timestamp,
                Time: o.Timestamp,
                ...o
            }
        }).sort((a,b) => (a.Timestamp ?? Date()) < (b.Timestamp ?? Date()) ? 1 : -1);
    }, [data, props.tabIndex])

    return (

        <DataGridPremium
            apiRef={apiRef}
            autoHeight
            rows={aggregatedData}
            columns={columns}
            pagination
            loading={status === Status.Fetching || status === Status.Idle}
            groupingColDef={{
                headerName: ' ',
                valueGetter: (params: GridValueGetterParams) => '',
                width: 50,
                resizable: false,
                hideable: false,                
            }}
        />
    );
}

export default AuditLogGrid;
